import { Box, TextPreset } from '@facile-it/full-metal-ui/components'
import type { NextPage } from 'next'
import Head from 'next/head'
import * as React from 'react'
import { Container, HeroContainer, HeroContent, HeroTitle, ManOnTheCar, Spec, SpecContainer } from '../components'
import { ChiSiamo } from '../components/ChiSiamo'
import { Ctas } from '../components/Ctas'
import { AppLink } from '../components/routing/AppLink'
import { routes } from '../routes'
import * as styles from '../styles/Pages.css'

const Assicurazioni: NextPage = () => (
    <>
        <Head>
            <title>Assicurazioni | Saturno assicurazioni</title>
        </Head>
        <HeroContainer hasBackground>
            <Box className={styles.heroImageWrapper}>
                <Box className={[styles.heroImage, styles.heroImageAlt]}>
                    <ManOnTheCar />
                </Box>
            </Box>
            <HeroContent>
                <HeroTitle>Assicurazioni Auto e Moto</HeroTitle>
                {/* 
                    
                    !! THIS PIECE WILL BE ACTIVATED LATER !!

                    <HeroCaption>
                        Offerte a partire da <strong>178€</strong>*
                    </HeroCaption> */}
                {/* <Ctas /> */}
                <TextPreset
                    preset="paragraph-m"
                    paddingTop="s"
                    paddingLeft={{ mobile: 'none', tablet: 'l', desktop: 's' }}
                    className={styles.maxWidth}
                >
                    Saturno è un prodotto assicurativo della <strong>Compagnia Wakam S.A.</strong>, distribuito da{' '}
                    <strong>Brokerhero s.r.l.</strong> in collaborazione esclusiva con{' '}
                    <strong>Facile.it Broker di Assicurazioni S.p.A.</strong>
                    <AppLink href={routes.chisiamo} paddingLeft="xxs">
                        <u>Scopri di più</u>
                    </AppLink>
                </TextPreset>
            </HeroContent>
        </HeroContainer>
        <Container
            display="flex"
            flexDirection="column"
            justifyContent="center"
            textAlign="center"
            marginTop={{ mobile: 'none', desktop: 'l' }}
            paddingX={{ mobile: 'm', desktop: 'none' }}
            paddingTop="3xl"
            paddingBottom={{ mobile: 'm', desktop: 'xxs' }}
        >
            <Box paddingTop="xs">
                <Box
                    component="p"
                    className={styles.otherBlue}
                    fontSize={{ mobile: 1.5, desktop: 2.25 }}
                    fontWeight="bold"
                    marginBottom="s"
                    paddingBottom="xxs"
                >
                    Garanzie accessorie
                </Box>
                <TextPreset
                    preset="paragraph-xl"
                    fontWeight="medium"
                    className={styles.specialLineHeight}
                    paddingX={{ mobile: 'xs', tablet: 'none' }}
                    paddingBottom="3xs"
                >
                    Ti offriamo una <strong>polizza auto completa e flessibile</strong>.
                </TextPreset>
                <TextPreset
                    preset="paragraph-xl"
                    fontWeight="medium"
                    className={styles.specialLineHeight}
                    paddingX={{ mobile: 'xs', tablet: 'none' }}
                    paddingBottom="l"
                >
                    Personalizzala con le coperture non incluse dalla classica RC in base alle tue esigenze, ed evita
                    spese impreviste.
                </TextPreset>
            </Box>
        </Container>
        <Box paddingX={{ mobile: 'm', desktop: 'none' }}>
            <Container paddingBottom="m">
                <SpecContainer paddingBottom={{ mobile: 'none', desktop: 'xl' }}>
                    <Spec type="car" title="RC Auto">
                        Copre i danni materiali e fisici causati a terzi in caso di sinistro.
                    </Spec>
                    <Spec type="towtruck" title="Assistenza stradale">
                        Garantisce il recupero e il traino del mezzo in caso di incidente.
                    </Spec>
                    <Spec type="scales" title="Assistenza legale">
                        Copre le spese conseguenti ai contenziosi legali in caso di sinistro.
                    </Spec>
                    <Spec type="doctor" title="Infortuni conducente">
                        Rimborsa il conducente in caso di danni fisici dovuti a un sinistro.
                    </Spec>
                </SpecContainer>
            </Container>
            {/* <Ctas centered /> */}
            <Container
                marginTop="hugexxl"
                marginBottom="3xl"
                paddingX="none"
                paddingBottom={{ mobile: 'l', tablet: 'xl' }}
            >
                <ChiSiamo />
            </Container>
        </Box>
    </>
)

export default Assicurazioni
